/** Webapp collection code for providers-kind drill routes (`/social-casino/providers/provider/...`). */
export const CASINO_PROVIDER_DEEPLINK_COLLECTION_SLUG = "providers";
